/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TnCredsRelatedToTnDto
 */
export interface TnCredsRelatedToTnDto {
    /**
     * 
     * @type {string}
     * @memberof TnCredsRelatedToTnDto
     */
    tnSaid?: string;
}

/**
 * Check if a given object implements the TnCredsRelatedToTnDto interface.
 */
export function instanceOfTnCredsRelatedToTnDto(value: object): boolean {
    return true;
}

export function TnCredsRelatedToTnDtoFromJSON(json: any): TnCredsRelatedToTnDto {
    return TnCredsRelatedToTnDtoFromJSONTyped(json, false);
}

export function TnCredsRelatedToTnDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TnCredsRelatedToTnDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tnSaid': json['tnSaid'] == null ? undefined : json['tnSaid'],
    };
}

export function TnCredsRelatedToTnDtoToJSON(value?: TnCredsRelatedToTnDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tnSaid': value['tnSaid'],
    };
}

